import React, { useState } from 'react';
import styles from './AddressInfo.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const AddressInfo = (props) => {

    const handleCheckboxChange = (e) => {
        props.setUseSameAddress(e.target.checked);
    };

    const handleDeliveryAddressChange = (e) => {
        const { name, value } = e.target;
        props.setDeliveryAddress((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleBillingAddressChange = (e) => {
        const { name, value } = e.target;
        props.setBillingAddress((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    return (
        <div className={styles.container}>
            <h2>Adresa de livrare</h2>
            <form>
                <div className={styles.row}>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="name">Nume</label>
                        <input className={styles.input} type="text" id="name" name="name"
                            value={props.deliveryAddress.name} onChange={handleDeliveryAddressChange} required />
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="email">Email</label>
                        <input className={styles.input} type="email" id="email" name="email"
                            value={props.deliveryAddress.email} onChange={handleDeliveryAddressChange} required />
                    </div>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="phone">Telefon</label>
                        <input className={styles.input} type="tel" id="phone" name="phone"
                            value={props.deliveryAddress.phone} onChange={handleDeliveryAddressChange} required />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="address">Strada și numărul</label>
                        <input className={styles.input} type="text" id="address" name="address"
                            value={props.deliveryAddress.address} onChange={handleDeliveryAddressChange} required />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="city">Oraș</label>
                        <input className={styles.input} type="text" id="city" name="city"
                            value={props.deliveryAddress.city} onChange={handleDeliveryAddressChange} required />
                    </div>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="postalCode">Cod poștal</label>
                        <input className={styles.input} type="text" id="postalCode" name="postalCode"
                            value={props.deliveryAddress.postalCode} onChange={handleDeliveryAddressChange} required />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.field}>
                        <label className={styles.label} htmlFor="country">Țară</label>
                        <select className={styles.input} id="country" name="country"
                            value={props.deliveryAddress.country} onChange={handleDeliveryAddressChange} required>
                            <option value="">Alege țara...</option>
                            <option value="3">
                                Afganistan
                            </option>

                        </select>
                    </div>
                </div>

                <div className={styles.row}>
                    <label>
                        <input
                            type="checkbox"
                            checked={props.useSameAddress}
                            onChange={handleCheckboxChange}
                        /> Foloseste aceeasi adresa pentru facturare
                    </label>
                </div>
                {!props.useSameAddress &&
                    <div>
                        <h2>Adresa de facturare</h2>
                        <div className={styles.row}>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="name">Nume</label>
                                <input className={styles.input} type="text" id="name" name="name"
                                    value={props.billingAddress.name} onChange={handleBillingAddressChange} required />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="email">Email</label>
                                <input className={styles.input} type="email" id="email" name="email"
                                    value={props.billingAddress.email} onChange={handleBillingAddressChange} required />
                            </div>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="phone">Telefon</label>
                                <input className={styles.input} type="tel" id="phone" name="phone"
                                    value={props.billingAddress.phone} onChange={handleBillingAddressChange} required />
                            </div>
                        </div>

                        <div className={styles.row}>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="companyName">Numele companiei</label>
                                <input className={styles.input} type="text" id="companyName"
                                    name="companyName" value={props.billingAddress.companyName} onChange={handleBillingAddressChange} required />
                            </div>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="cui">CUI / TVA</label>
                                <input className={styles.input} type="text" id="cui" name="cui"
                                    value={props.billingAddress.cui} onChange={handleBillingAddressChange} required />
                            </div>
                        </div>

                        <div className={styles.row}>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="address">Strada și numărul</label>
                                <input className={styles.input} type="text" id="address" name="address"
                                    value={props.billingAddress.address} onChange={handleBillingAddressChange} required />
                            </div>
                        </div>

                        <div className={styles.row}>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="city">Oraș</label>
                                <input className={styles.input} type="text" id="city" name="city"
                                    value={props.billingAddress.city} onChange={handleBillingAddressChange} required />
                            </div>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="postalCode">Cod poștal</label>
                                <input className={styles.input} type="text" id="postalCode" name="postalCode"
                                    value={props.billingAddress.postalCode} onChange={handleBillingAddressChange} required />
                            </div>
                        </div>

                        <div className={styles.row}>
                            <div className={styles.field}>
                                <label className={styles.label} htmlFor="country">Țară</label>
                                <select className={styles.input} id="country" name="country"
                                    value={props.billingAddress.country} onChange={handleBillingAddressChange} required>
                                    <option value="">Alege țara...</option>
                                    <option value="3">
                                        Afganistan
                                    </option>

                                </select>
                            </div>
                        </div>
                    </div>
                }
            </form>
        </div>
    );
};

export default AddressInfo;
